import { LayoutGrid, Plus } from 'lucide-react';
import { useCallback, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '@aimsos/i18n';
import { useDashboardData } from '../context';
import DashboardBuilderCard from './DashboardBuilderCard';
import DashboardButton from './DashboardButton';

const DashboardEmptyState = () => {
  const { t } = useTranslation('dashboards');
  const navigate = useNavigate();
  const { templates, fetchTemplates } = useDashboardData();
  const handleCreateDashboard = useCallback(() => navigate('/dashboards/new'), [navigate]);

  useEffect(() => {
    fetchTemplates();
  }, [fetchTemplates]);

  const suggestedTemplates = useMemo(() => templates.slice(0, 3), [templates]);

  return (
    <section>
      <div className="flex flex-col gap-6">
        <div className="flex flex-col items-center gap-4 rounded-2xl border border-edge bg-surface px-6 py-10 text-center">
          <span className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-brand-50 text-brand-600 dark:bg-brand-950/40 dark:text-brand-400">
            <LayoutGrid size={20} />
          </span>
          <h2 className="text-lg font-semibold text-content">{t('list.emptyState.title')}</h2>
          <p className="max-w-xl text-sm text-content-muted">{t('list.emptyState.description')}</p>
          <DashboardButton rightIcon={Plus} onClick={handleCreateDashboard}>
            {t('list.emptyState.createButton')}
          </DashboardButton>
        </div>

        {suggestedTemplates.length > 0 && (
          <div className="flex flex-col gap-3">
            <h3 className="text-sm font-semibold text-content-secondary">{t('list.emptyState.suggestedTemplates')}</h3>
            <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
              {suggestedTemplates.map((template) => (
                <DashboardBuilderCard key={template.id} dashboard={template} />
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default DashboardEmptyState;
